<template>
    <div class="BlankAddPage">
		<div class="bntGroup">
			<base-button @click="GoBack()" type="primary" class="no-border my-0" simple icon><i class="d-inline-block tim-icons icon-simple-remove"></i></base-button>
		</div>
		<card>
			<ReFormPrinter 
				:masFormConfig="masAllFormParams" 
				:objSaveApiMethod="currentApiFormMethod"		
				:SuccessGo="SuccessGo"
				SuccessBtnText="Добавить"/>
		</card>
	</div>
</template>
<script>

import ReFormPrinter from 'src/our_components/FormPrinter/ReFormPrinter.vue';
export default {
	name: 'blank-add-page',
	components: {
		ReFormPrinter
	},
	data() {
		return {
			currentApiFormMethod: this.currentApiFormMethodComp(),
			masAllFormParams: this.currentFormConfig(),
		};
	},
	methods: {
		currentApiFormMethodComp(){
			return {apiMethod:'INS',apiParam:{obj:'blanks' ,flt:{},iData:[]}};
		},
		currentFormConfig(){
			this.$GVO.ApiCall('GET_FORM',{obj:'blanks',flt:{}})
				.then((objApi) => {
					//console.log(objApi);
					if(objApi.success){
						this.masAllFormParams = objApi.config;
					}
				})
				.catch(errorObjApi => console.error(errorObjApi));
			return [];
		},
		SuccessGo(evt){
			location.href = '/data/blanks';
			return true;
		},
		sendBlank(){
			this.$GVO.ApiCall('blanks.INS',{'iData':{
				'staffId':11955,
				'structureId':'2E944C9B-B1F4-11E4-AF2E-080027B197A1',
				'autorId':2601,
				'clientId':7499,
				'blank_type':'Договор',
				'blank_service_type':'вид услуги',
				'blank_service':'услуга',
			}})
			.then((objApi) => {
				if(objApi.success === true){
					if(objApi.data.length > 0){
						this.ApiData = objApi.data;
					}
				}
			}).catch(errorObjApi => console.error(errorObjApi));
		},
		GoBack(){
			this.$router.back();
			// this.$router.push({path: '/data/clients/id/'+this.$route.params.client_id});
		},
		
	},		
	mounted() {

	}
};
</script>
<style scoped>
.BlankAddPage .bntGroup{
		position: absolute;
		z-index: 1;
		right: 40px;
	}
</style>
